export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReELSEttMzE0LUI1LUhhDKFLAOpODgDrLwEA6zEAAYECAgGBBgIBgQoCAYEOAgGBEgIBgRYCAYEaAgGBHmgA6k8=", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/HKm314-B5-V.bcmap
// module id = 661
// module chunks = 502